import {BrowserRouter, Route, Routes} from "react-router-dom";
import './App.css'
import NavBar from "./components/NavBar";
import {RequestPage} from "./components/RequestPage";
import {useEffect, useState} from "react";
import {FieldsPage} from "./components/FieldsPage";
import {LOCALES} from './i18n/locales.js';
import {IntlProvider} from "react-intl";
import {messages} from "./i18n/messages.";
import {DictionaryPage} from "./components/DictionaryPage";
import {ObjectsPage} from "./components/ObjectsPage";
import {LoaderProvider} from "./components/context/LoaderContext";


export const host = 'https://docs.cleverstaff.net/hr';

function App() {

    const [page, setPage] = useState("Api");
    let l = localStorage.getItem("lang") ? localStorage.getItem("lang") : "En";
    const [lang, setLang] = useState(l);


    const [locale, setLocale] = useState(LOCALES.ENGLISH);

    useEffect(() => {
        switch (lang) {
            case "Ua" :
                setLocale(LOCALES.UKRAINIAN)
                break;
            case "En" :
                setLocale(LOCALES.ENGLISH)
                break;
            default :
                setLocale(LOCALES.ENGLISH)
                break
        }
    }, [lang])

    return (
        <LoaderProvider>
            <IntlProvider
                messages={messages[locale]}
                locale={locale}
                defaultLocale={LOCALES.ENGLISH}
            >
                <BrowserRouter>
                    <NavBar page={page} setPage={setPage} lang={lang} setLang={setLang}/>
                    <div className="background">
                        <Routes>

                            {['', 'api'].map((path, i) => <Route key={i} path={path}
                                                                 element={<RequestPage onEnter={() => {
                                                                     setPage("Api")
                                                                 }}/>}/>)}
                            <Route path="/fields" element={<FieldsPage onEnter={() => {
                                setPage("Fields")
                            }}/>}/>
                            <Route path="/dictionary" element={<DictionaryPage onEnter={() => {
                                setPage("Dictionary")
                            }}/>}/>
                            <Route path="/object" element={<ObjectsPage onEnter={() => {
                                setPage("Objects")
                            }}/>}/>
                        </Routes>
                    </div>
                </BrowserRouter>
            </IntlProvider>
        </LoaderProvider>
    );
}

export default App;
